"use client";
import React, { useEffect, useState, useContext } from "react";
import { connectUserWallet, getWallet, modifiedTokenHash, checkIsPremium, minPremiumAmount } from "../../Utils/utils";
import { WalletContext } from "../../contexts/Wallet-context";
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { WagmiConfig, createConfig } from 'wagmi';
import { mainnet } from 'viem/chains';
import { http } from 'viem';
import { useAccount, useConnect, useDisconnect, useContractRead, useBalance } from 'wagmi';
import { erc20Abi, formatUnits } from "viem";
import { readContract } from '@wagmi/core';
const SGT_TOKEN_ADDRESS = '0xa0e7626287bd02cbe3531c65148261bf0c0ed98b';

// Simple injected connector for wagmi 2.x
function injectedConnector() {
  return () => ({
    id: 'injected',
    name: 'Browser Wallet (MetaMask, Coinbase)',
    type: 'injected',
    async connect() {
      const provider = window.ethereum;
      if (!provider) throw new Error('No browser wallet found. Please install MetaMask or Coinbase Wallet.');
      
      const accounts = await provider.request({ 
        method: 'eth_requestAccounts' 
      });
      return { 
        accounts: accounts.map(x => x),
        chainId: Number(await provider.request({ method: 'eth_chainId' }))
      };
    },
    async disconnect() {
      // Injected wallets don't have a disconnect method
    },
    async getAccounts() {
      const provider = window.ethereum;
      if (!provider) return [];
      const accounts = await provider.request({ method: 'eth_accounts' });
      return accounts.map(x => x);
    },
    async getChainId() {
      const provider = window.ethereum;
      if (!provider) throw new Error('No provider');
      const chainId = await provider.request({ method: 'eth_chainId' });
      return Number(chainId);
    },
    async getProvider() {
      return window.ethereum;
    },
    async isAuthorized() {
      try {
        const accounts = await this.getAccounts();
        return accounts.length > 0;
      } catch {
        return false;
      }
    },
    onAccountsChanged(accounts) {
      if (accounts.length === 0) {
        this.onDisconnect?.();
      } else {
        this.onConnect?.({ accounts: accounts.map(x => x) });
      }
    },
    onChainChanged(chainId) {
      this.onConnect?.({ chainId: Number(chainId) });
    },
    onConnect() {},
    onDisconnect() {},
  });
}

// WalletConnect connector for wagmi 2.x

function walletConnectConnector() {
  return () => ({
    id: 'walletConnect',
    name: 'WalletConnect (Trust Wallet, Rainbow, etc.)',
    type: 'walletConnect',
    async connect() {
      
    const WalletConnectProvider = (await import('@walletconnect/ethereum-provider')).default;
    
    const provider = await WalletConnectProvider.init({
        projectId: '8333166464ccc14283231b37282cea35',
        chains: [1], // Mainnet
        showQrModal: true,
        qrModalOptions: {
        themeMode: 'dark',
        },
    });

    await provider.connect();
    
    const accounts = provider.accounts;
    const chainId = provider.chainId;
    
    if(accounts.length > 0) {
        window.location.reload();
    }
    // Store provider for later use
    this._provider = provider;
    
    return { 
        accounts,
        chainId: Number(chainId)
    };
      
    },
    async disconnect() {
      if (this._provider) {
        await this._provider.disconnect();
        this._provider = null;
      }
    },
    async getAccounts() {
      if (!this._provider) return [];
      return this._provider.accounts || [];
    },
    async getChainId() {
      if (!this._provider) throw new Error('No provider');
      return Number(this._provider.chainId);
    },
    async getProvider() {
      return this._provider;
    },
    async isAuthorized() {
      try {
        const accounts = await this.getAccounts();
        return accounts.length > 0;
      } catch {
        return false;
      }
    },
    onAccountsChanged(accounts) {
      if (accounts.length === 0) {
        this.onDisconnect?.();
      } else {
        this.onConnect?.({ accounts });
      }
    },
    onChainChanged(chainId) {
      this.onConnect?.({ chainId: Number(chainId) });
    },
    onConnect() {
      
    },
    onDisconnect() {},
  });
}

// Create wagmi config for wagmi 2.x
const config = createConfig({
  chains: [mainnet],
  connectors: [injectedConnector(), walletConnectConnector()],
  transports: {
    [mainnet.id]: http(`https://eth-mainnet.g.alchemy.com/v2/AHOsWI9ZVnMhM--r7aSqH`),
  },
});

// Create a client
const queryClient = new QueryClient();

export function WalletOptions() {
  const { connect, connectors } = useConnect();

  return connectors.map((connector) => (
    <WalletOption
      key={connector.id}
      connector={connector}
      onClick={() => connect({ connector })}
    />
  ));
}

function WalletOption({ connector, onClick }) {
  const [ready, setReady] = useState(false);

  useEffect(() => {
    (async () => {
      const provider = await connector.getProvider();
      setReady(!!provider);
    })();
  }, [connector]);

  return (
    <button disabled={!ready} onClick={onClick}>
      {connector.name}
    </button>
  );
}

export function Connection() {
  const { address } = useAccount();
  const { disconnect } = useDisconnect();

  return (
    <div>
      {address && <div>{address}</div>}
      <button onClick={() => disconnect()}>Disconnect</button>
    </div>
  );
}

const WalletComponent = () => {
  const [walletAmount, setWalletAmount] = useState(0);
  const [openAcount, setOpenAcount] = useState(false);
  const walletContext = useContext(WalletContext);
  const { wallet, setWallet } = walletContext;
  const [connectClick, setConnectClick] = useState(false);
  const [isLogout, setIsLogout] = useState(false);
  const [isPremium, setIspremium] = useState(checkIsPremium(wallet));

  const openConnect = (e) => {
    // if (e?.target?.closest && e.target.closest('.popup-dialog')) {
    //   setOpen(true);
    // } else {
    //   setOpen(!open);
    // }
  };

  const Balance = React.memo((props) => {
    // get live data realtime instead localstorage data
    let { address, isConnected } = useAccount();
    if(address === undefined && props.address) {
        address = props.address;
    }
    
    //const { data: nativeBalance } = useBalance({ address, watch: true });
    let { data: sgtBalance, isLoading: sgtLoading, error: sgtError } =
    useBalance({
        address,
        token: SGT_TOKEN_ADDRESS,
        unit: 'ether',  // fix BigInt problem
    });

    let wallet = {
        address: props.address,
        amount: sgtBalance ? sgtBalance?.formatted : 0
    };
    
    let balanceString = "";
    if(sgtBalance && sgtBalance?.formatted && sgtBalance?.symbol) {
      balanceString = `${Math.round(sgtBalance?.formatted)} ${sgtBalance?.symbol}`;
      //walletContext.setWallet(wallet);
    }

    if(isConnected && !isLogout && !localStorage.getItem('userWallet') && !sgtLoading) {
        // Save to localStorage
        localStorage.setItem('userWallet', JSON.stringify(wallet));
        setTimeout(() => {
          window.location.reload();
        }, 500);
    }
    if(isLogout && localStorage.getItem('userWallet')) {
        localStorage.removeItem('userWallet');
    }

    // useEffect(() => {
    //   if (!isConnected || !address || localStorage.getItem('userWallet')) return
    //     localStorage.setItem('userWallet', JSON.stringify(wallet))
    // }, [])


    return (
    <div>
      {sgtBalance && <>
        <span className="amount">
        {sgtLoading
            ? 'Loading…'
            : sgtError
            ? 'Error'
            : sgtBalance?.formatted
            ? balanceString
            : '0 SGT'}
        </span>
      </>}
    </div>
    )
  })

  const displayUserInfo = () => {
    const w = getWallet();
    if (w?.amount !== null && w?.amount !== undefined) {
      setWalletAmount(w.amount);
      walletContext.setWallet(w);
    }
  };

  const logout = () => {
    localStorage.removeItem('userWallet');
    setWalletAmount(0);
    walletContext.setWallet(null);
    setIsLogout(true);
    setOpenAcount(false);
  };

  useEffect(() => {
    displayUserInfo();
    const premium = checkIsPremium();
    setIspremium(premium);
  }, []);

  // Child component inside WagmiConfig so hooks work
  function WalletUI() {
    const walletContext = useContext(WalletContext);
    let { isConnected, address } = useAccount();
    const { disconnect } = useDisconnect();
    const { connect, connectors } = useConnect();
    const isWalletConnected = JSON.parse(localStorage.getItem('userWallet'));
    let [isPremium, setIsPremium] = useState(false);
    const [amount, setAmount] = useState(0);
    
    const checkConnection = async () => {
      const connector = injectedConnector()();
      const connected = await connector.isAuthorized();
      if (connected) {
        const accounts = await connector.getAccounts();
        const chainId = await connector.getChainId();
        const tokenAddress = SGT_TOKEN_ADDRESS;
        const walletAddress = accounts[0];
        if(tokenAddress && walletAddress) {
          const decimals = await readContract(config, {
            address: tokenAddress,
            abi: erc20Abi,
            functionName: 'decimals',
          })

          const balance = await readContract(config, {
            address: tokenAddress,
            abi: erc20Abi,
            functionName: 'balanceOf',
            args: [walletAddress],
          })

          const formatted = formatUnits(balance, decimals)
          console.log(formatted) 
          const obj = {
            address: walletAddress,
            amount: formatted
          }
          walletContext.setWallet(JSON.stringify(obj));
          localStorage.setItem('userWallet', JSON.stringify(obj));
          const premium = checkIsPremium(obj);
        }
      }
    }

    useEffect(() => {
      if (connectClick && isConnected && address) {
        connectUserWallet(address).then((result) => {
          if (result && !result.errorMsg) {
            displayUserInfo();
          }
        });
      }
    }, [isConnected]);

    const handleDisconnect = () => {
      setConnectClick(false);
      disconnect();
      logout();
      setOpenAcount(false);
    };

    const openAccountInfo = () => {
        if(openAcount) {
          setOpenAcount(false);
        }
        else {
          setOpenAcount(true);
        }
    };

    const handleConnect = (connector) => {
      setConnectClick(true);
      if(!localStorage.getItem('userWallet')) {
        connect({ connector });
      }
      setIsLogout(false);
      setOpenAcount(false);
    };

    return (
      <div className="wallet-comp gray-bg gray-border rounded align-left" onClick={openAccountInfo}>
        
        {address || (isWalletConnected && isWalletConnected.address)? (
          <>
            <div className="connected" style={{"minHeight": "42px"}}>
              <span>
                <span>{modifiedTokenHash(address !== undefined ? address : isWalletConnected.address)}</span>
                <Balance address={address !== undefined ? address : isWalletConnected.address} isPremium={isPremium}/>
              </span>
              <span className={isPremium ? "user-icon premium" : "user-icon"} onClick={openAccountInfo}></span>
              {openAcount ? (
                <div className="popup-dialog gray-bg rounded">
                  <div className="wallet-lbl">Wallet: <span>{address !== undefined ? address : isWalletConnected.address}</span></div>
                  <div className="h-20"></div>
                  <div><Balance address={address !== undefined ? address : isWalletConnected.address} /></div>
                  <button onClick={handleDisconnect} className="gray-bg gray-border rounded">Logout</button>
                </div>
              ) : null}
            </div>
          </>
        ) : (
            <div className="connect-w">
                <span>Connect wallet</span>
                <span className="user-icon"></span>
                {openAcount ? (
                <div className="popup-dialog gray-bg rounded align-left">
                    {connectors.map((connector, index) => (
                    <div 
                        key={index}
                        onClick={() => handleConnect(connector)} 
                        className="gray-bg gray-border rounded connector-btn"
                        style={{ marginBottom: '10px', width: '100%' }}
                    >
                        Connect with {connector.name}
                    </div>
                    ))}
                </div>
                ) : null}
            </div>
        )}
      </div>
    );
  }

  return (
    <WagmiConfig config={config}>
      <QueryClientProvider client={queryClient}>
        <WalletUI />
      </QueryClientProvider>
    </WagmiConfig>
  );
};

export default WalletComponent;
